import React from 'react';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import '../masters/CategoryMaster.css';

const OdcListHeader = ({ filters, setFilters, options, loading, onReset }) => {
    const userRole = localStorage.getItem('role');

    return (
        <>
            <div className="mb-4">
                <h2 className="text-3xl font-bold mb-2" style={{ color: 'var(--primary-color)' }}>
                    ODC Order List
                </h2>
                <p className="text-color-secondary">View and manage outdoor catering orders</p>
            </div>

            <Card className="mb-3 bill-reports-filter-card">
                <div className="flex flex-wrap align-items-end bill-reports-filter-row">
                    <div className="flex flex-column" style={{ flex: '1 1 140px', minWidth: '130px' }}>
                        <label>Status</label>
                        <Dropdown value={filters.selectedStatus} options={options.statusOptions} onChange={(e) => setFilters({ ...filters, selectedStatus: e.value })} placeholder="All Status" className="w-full" showClear />
                    </div>

                    <div className="flex flex-column" style={{ flex: '1 1 200px', minWidth: '180px' }}>
                        <label>Date Range</label>
                        <Calendar value={filters.dates} onChange={(e) => setFilters({ ...filters, dates: e.value })} selectionMode="range" readOnlyInput showIcon placeholder="Select Dates" className="w-full" />
                    </div>

                    <div className="flex flex-column" style={{ flex: '1 1 175px', minWidth: '155px' }}>
                        <label>Company</label>
                        <Dropdown value={filters.selectedCompany} options={options.companies} optionLabel="company_name" optionValue="company_id" onChange={(e) => setFilters({ ...filters, selectedCompany: e.value })} placeholder="All Companies" filter showClear className="w-full" />
                    </div>

                    {userRole === 'CEO' && (
                        <div className="flex flex-column" style={{ flex: '1 1 175px', minWidth: '155px' }}>
                            <label>Branch</label>
                            <Dropdown value={filters.selectedBranch} options={options.branches} optionLabel="branch_name" optionValue="branch_id" onChange={(e) => setFilters({ ...filters, selectedBranch: e.value })} placeholder="All Branches" filter showClear className="w-full" />
                        </div>
                    )}

                    <div className="flex gap-2" style={{ flex: '0 0 auto' }}>
                        <Button icon="pi pi-refresh" className="p-button-secondary" onClick={onReset} disabled={loading} tooltip="Reset Filters" />
                    </div>
                </div>
            </Card>
        </>
    );
};

export default OdcListHeader;
